module.exports = __webpack_public_path__ + "static/media/logo2023.be4b3c9f.png";